import { Backdrop } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GENERAL__CANCEL_BUTTON, GENERAL__CONFIRM } from 'translations/constants';
import {
  GeneralConfirmModalStyled,
  ModalActionButton,
  ModalActionContainer,
  ModalContainer,
  ModalContent,
} from './styles';
import { GeneralConfirmModalProps } from './types';

const GeneralConfirmModal: React.FC<GeneralConfirmModalProps> = ({
  open,
  onClose,
  content,
  onAction,
  confirmTestId,
  cancelTestId,
  actionDisabled,
}) => {
  const [t] = useTranslation();

  return (
    <Backdrop open={open} sx={{ zIndex: '2000' }}>
      <GeneralConfirmModalStyled open={open} onClose={onClose}>
        <ModalContainer>
          <ModalContent>{content}</ModalContent>
          <ModalActionContainer>
            <ModalActionButton
              text={t(GENERAL__CONFIRM)}
              onClick={onAction}
              disabled={actionDisabled}
              testId={confirmTestId}
            />
            <ModalActionButton text={t(GENERAL__CANCEL_BUTTON)} outlined onClick={onClose} testId={cancelTestId} />
          </ModalActionContainer>
        </ModalContainer>
      </GeneralConfirmModalStyled>
    </Backdrop>
  );
};

export default GeneralConfirmModal;
